@if (title) {
  @if (componentType === 'companyBackground') {
    <div
      class="policy-section-head cursor-select"
      (click)="isCollapsed = !isCollapsed"
    >
      <i
        class="bi policy-toggle"
        [ngClass]="{
          'bi-plus-square-fill': isCollapsed,
          'bi-dash-square-fill': !isCollapsed
        }"
      ></i>
      <label class="policy-title cursor-select">{{ title }}</label>
      <span class="policy-status">
        <span class="fw-semibold chip-host" appStatusStyleChanges>{{
          result
        }}</span>
      </span>
    </div>
    <div [(ngbCollapse)]="isCollapsed">
      <div class="policy-finding-detail">
        <div class="policy-finding-detail-row">
          <span class="policy-finding-detail-label">Finding:</span>
          <span>{{ getFinding(findings) }}</span>
        </div>
        <div class="policy-finding-detail-row">
          <span class="policy-finding-detail-label">Requirement:</span>
          <span>{{ getRequirement(settings) }}</span>
        </div>
      </div>
    </div>
  }

  @if (componentType === 'insurancePolicies') {
    <div
      class="policy-section-head cursor-select"
      (click)="isCollapsed = !isCollapsed"
    >
      <i
        class="bi policy-toggle"
        [ngClass]="{
          'bi-plus-square-fill': isCollapsed,
          'bi-dash-square-fill': !isCollapsed
        }"
      ></i>
      <label class="policy-title cursor-select">{{ title }}</label>
      <span class="policy-status">
        <span class="fw-semibold chip-host" appStatusStyleChanges>{{
          checkResultsForFailure(findingsAndSetting)
        }}</span>
      </span>
    </div>
    @for (item of findingsAndSetting; track item) {
      @if (item.enabled) {
        <div [(ngbCollapse)]="isCollapsed">
          <div
            class="policy-finding-row cursor-select"
            (click)="toggleCollapse(item.title)"
          >
            <span class="list-item policy-finding-label">{{ item.title }}</span>
            <span class="policy-finding-result">
              @if (isPassedResult(item.result)) {
                <img
                  src="assets/images/vive-v-circle-green.svg"
                  class="brand-check-sm"
                  alt="Passed"
                />
              } @else {
                <span class="chip-host" appStatusStyleChanges>{{
                  item.result
                }}</span>
              }
            </span>
          </div>
          <div [(ngbCollapse)]="collapseStates[item.title]">
            <div class="policy-finding-detail">
              <div class="policy-finding-detail-row">
                <span class="policy-finding-detail-label">Finding:</span>
                <span>{{ getFinding(item.finding) }}</span>
              </div>
              <div class="policy-finding-detail-row">
                <span class="policy-finding-detail-label">Requirement:</span>
                <span>{{ getRequirement(item.setting) }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    }
  }
}
